import { Box, Typography, useTheme } from '@mui/material';

interface StickyHeaderProps {
  title: string;
  showStickyHeader: boolean;
}

function StickyHeader({ title, showStickyHeader }: StickyHeaderProps) {
  const theme = useTheme();

  return (
    <Box sx={{ position: 'sticky', top: 0, height: 0, zIndex: 5, width: '100%' }}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: theme.palette.sand.main,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          px: 2,
          py: 1,
          minHeight: '70px',
          borderBottom: `1px solid ${theme.palette.sandShade4.main}`,
          opacity: showStickyHeader ? 1 : 0,
          transform: showStickyHeader ? 'translateY(0)' : 'translateY(-100%)',
          pointerEvents: showStickyHeader ? 'auto' : 'none',
          transition: 'opacity 0.2s ease, transform 0.2s ease',
          backdropFilter: 'none',
          willChange: 'opacity, transform',
        }}
      >
        <Typography variant='h2'>{title}</Typography>
      </Box>
    </Box>
  );
}

export default StickyHeader;
